import type { QuotaType } from '~/stores/documentQuotaStore';
import { useDocumentQuotaStore } from '~/stores/documentQuotaStore';

export type DocumentQuotaState = 'below_threshold' | 'above_threshold' | 'reached';

export const useDocumentQuota = (quotaType: QuotaType = 'documents') => {
    const quotaStore = useDocumentQuotaStore();

    const quota = computed(() => quotaStore.getQuota(quotaType));

    const hasQuota = computed(() => quota.value !== null);

    const limit = computed(() => quota.value?.limit ?? 0);
    const used = computed(() => quota.value?.usage ?? 0);

    const percentage = computed(() => (limit.value ? (used.value / limit.value) * 100 : 0));

    const state = computed<DocumentQuotaState>(() => {
        if (percentage.value >= 100) return 'reached';
        if (percentage.value >= 80) return 'above_threshold';
        return 'below_threshold';
    });

    const isReached = computed(() => state.value === 'reached');

    return { hasQuota, limit, used, percentage, state, isReached };
};
